<template>
  <div class="main-panel">
    <div class="content-wrapper">
      <div class="row">
        <div class="col-12">
          <div class="d-lg-flex">
            <h1 class="font-weight-bold mb-4 mr-5 text-center">Setup your Account profile</h1>
            <hr />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-10 mx-auto">
          <div class="card">
            <div class="card-body border-bottom">
              <h4 class="font-weight-bold">Your Personal Information</h4>
            </div>
            <div class="card-body" v-if="viewMode.personalInfo">
              <div class="row">
                <div class="col-lg-7">
                  <div class="form-group">
                    <label for>Your name</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="newDetails.fullname"
                      placeholder="Your name"
                    />
                  </div>
                  <div class="form-group">
                    <label for>Your phone number</label>
                    <vue-tel-input
                      v-model="newDetails.phone"
                      :inputClasses="'form-control'"
                      :placeholder="'Your phone number'"
                      :defaultCountry="'Rwanda'"
                      :validCharactersOnly="true"
                    />
                  </div>
                  <div class="form-group">
                    <label for>Your Email</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="newDetails.email"
                      placeholder="Email address"
                    />
                  </div>
                  <div class="form-group">
                    <label>Profession</label>
                    <select class="form-control form-control-lg" v-model="newDetails.profession">
                      <option value="null" hidden disabled>Select your profession</option>
                      <option>Manager</option>
                      <option>Consultant</option>
                      <option>Designer</option>
                      <option>Marketer</option>
                      <option>Developer</option>
                      <option>Writer</option>
                      <option>Photographer</option>
                      <option>Videographer</option>
                      <option>Translator</option>
                      <option>Accountiing/Finance</option>
                      <option>Law</option>
                      <option>Other</option>
                    </select>
                  </div>
                  <div class="form-group">
                    <label>Experience</label>
                    <select
                      name
                      id
                      class="form-control form-control-lg"
                      v-model="newDetails.experience"
                    >
                      <option value="null" hidden disabled>Select experience</option>
                      <option>Beginner(0-3 years)</option>
                      <option>Intermediate(4-6 years)</option>
                      <option>Expert(6+ years)</option>
                    </select>
                  </div>
                  <div class="form-group row">
                    <label class="col-sm-3 col-form-label">Organization</label>
                    <div class="col-sm-4">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            type="radio"
                            class="form-check-input"
                            name="membershipRadios"
                            id="membershipRadios1"
                            value="solo"
                            v-model="newDetails.team_mode"
                          />
                          I work Solo
                          <i class="input-helper"></i>
                        </label>
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            type="radio"
                            class="form-check-input"
                            name="membershipRadios"
                            id="membershipRadios2"
                            value="team"
                            v-model="newDetails.team_mode"
                          />
                          I work in a team
                          <i class="input-helper"></i>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-5">
                  <h3 class="text-center mb-4">Profile photo</h3>
                  <div class="w-100 d-flex">
                    <my-upload
                      field="duka_upload"
                      @crop-success="dukaCropSuccess"
                      @crop-upload-success="dukaUploadSuccess"
                      v-model="showSingleUpload"
                      :width="100"
                      :height="100"
                      :url="trashedImageUrl"
                      lang-type="en"
                      ref="singleUpload"
                      img-format="png"
                      key="avatarUpload"
                    />
                    <div class="mx-auto" v-if="defaultCropImage">
                      <p class="text-center">
                        <img
                          :src="defaultCropImage"
                          class="img img-fluid rounded-circle img-thumbnail mx-auto"
                          style="width:100px; height:100px"
                        />
                      </p>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-info mt-3"
                        @click="toggleSingleUpload"
                      >
                        <span v-if="defaultCropImage">Edit Photo</span>
                        <span v-else>Upload Photo</span>
                      </button>
                    </div>
                    <div class="mx-auto text-center" v-else>
                      <h2 class="img-thumbnail p-4 rounded-circle">
                        <i class="mdi mdi-account text-primary" style="font-size: 81px;"></i>
                      </h2>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-info mt-3"
                        @click="toggleSingleUpload"
                      >
                        <span v-if="defaultCropImage">Edit Photo</span>
                        <span v-else>Upload Photo</span>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div class="mt-3 w-100">
                <router-link :to="{}" class="btn btn-secondary">Cancel</router-link>
                <button
                  type="button"
                  class="btn btn-primary btn-icon-text float-right"
                  @click="falseObject(viewMode, 'business')"
                >
                  Next
                  <i class="mdi mdi mdi-arrow-right-bold-circle btn-icon-append"></i>
                </button>
              </div>
            </div>
            <div class="card-body" v-if="viewMode.business">
              <div class="row">
                <div class="col-lg-7">
                  <div class="form-group">
                    <label for>Business Name</label>
                    <input
                      type="text"
                      v-model="newDetails.business_name"
                      class="form-control"
                      placeholder="Your business name"
                    />
                  </div>
                  <div class="form-group">
                    <label for>Business Address</label>
                    <input
                      type="text"
                      v-model="newDetails.business_address"
                      class="form-control"
                      placeholder="Address line"
                    />
                  </div>
                  <div class="form-group">
                    <label for>Business Email</label>
                    <input
                      type="text"
                      v-model="newDetails.business_email"
                      class="form-control"
                      placeholder="Email address"
                    />
                  </div>
                  <div class="form-group">
                    <label for>Business Phone</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="newDetails.business_phone"
                      placeholder="Phone number"
                    />
                  </div>
                </div>
                <div class="col-lg-5">
                  <h3 class="text-center mb-4">Business Logo</h3>
                  <div class="w-100 d-flex">
                    <my-upload
                      field="duka_upload"
                      @crop-success="dukaGalleryImage"
                      @crop-upload-success="dukaGalleryUpload"
                      v-model="showGalleryUpload"
                      :width="500"
                      :height="200"
                      :url="trashedImageUrl"
                      lang-type="en"
                      ref="galleryUpload"
                      img-format="png"
                      key="logoUpload"
                    />
                    <div class="mx-auto" v-if="dukaGallery.length">
                      <p class="text-center">
                        <img
                          :src="dukaGallery[dukaGallery.length - 1].image"
                          class="img img-fluid rounded img-thumbnail mx-auto"
                        />
                      </p>
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-danger mt-3"
                        @click="dukaGallery=[];defaultCropGallery=[]"
                      >
                        <span>Remove</span>
                      </button>
                    </div>
                    <div
                      class="m-auto text-center business-logo-container w-100"
                      @click="toggleGalleryUpload"
                      v-else
                    >
                      <h4>Upload Logo</h4>
                      <p>500px by 200px</p>
                    </div>
                  </div>
                  <div>
                    <h4>Choose your brand color</h4>
                    <p>Your brand color will appear on client-facing documents and emails.</p>
                    <ul class="list-inline color-list single">
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #000"
                          @click="getExteriorColor('#000')"
                          :class="{'selected': newDetails.brand_color === '#000'}"
                        ></button>
                      </li>

                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #ccc"
                          @click="getExteriorColor('#ccc')"
                          :class="{'selected': newDetails.brand_color === '#ccc'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #999"
                          @click="getExteriorColor('#999')"
                          :class="{'selected': newDetails.brand_color === '#999'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #ebdec9"
                          @click="getExteriorColor('#ebdec9')"
                          :class="{'selected': newDetails.brand_color === '#ebdec9'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #996633"
                          @click="getExteriorColor('#996633')"
                          :class="{'selected': newDetails.brand_color === '#996633'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #ffcc66"
                          @click="getExteriorColor('#ffcc66')"
                          :class="{'selected': newDetails.brand_color === '#ffcc66'}"
                        ></button>
                      </li>

                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #ff9900"
                          @click="getExteriorColor('#ff9900')"
                          :class="{'selected': newDetails.brand_color === '#ff9900'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #cc3333"
                          @click="getExteriorColor('#cc3333')"
                          :class="{'selected': newDetails.brand_color === '#cc3333'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #ff3399"
                          @click="getExteriorColor('#ff3399')"
                          :class="{'selected': newDetails.brand_color === '#ff3399'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #9966cc"
                          @click="getExteriorColor('#9966cc')"
                          :class="{'selected': newDetails.brand_color === '#9966cc'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #0099ff"
                          @click="getExteriorColor('#0099ff')"
                          :class="{'selected': newDetails.brand_color === '#0099ff'}"
                        ></button>
                      </li>
                      <li>
                        <button
                          type="button"
                          class="btn btn-default"
                          style="background-color: #66cc66"
                          @click="getExteriorColor('#66cc66')"
                          :class="{'selected': newDetails.brand_color === '#66cc66'}"
                        ></button>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <hr />
              <div class="mt-3 w-100">
                <button
                  type="button"
                  class="btn btn-secondary btn-icon-text"
                  @click="falseObject(viewMode, 'personalInfo')"
                >
                  Back
                  <i class="mdi mdi mdi-arrow-left-bold-circle btn-icon-append"></i>
                </button>
                <div class="float-right">
                  <button
                    type="button"
                    class="btn btn-primary float-right btn-icon-text"
                    @click="updateCustomerProfile"
                  >
                    Save Changes
                    <i class="mdi mdi mdi-arrow-right-bold-circle btn-icon-append"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import myUpload from "vue-image-crop-upload";
import { VueTelInput } from "vue-tel-input";
export default {
  name: "Profile",
  components: {
    "my-upload": myUpload,
    "vue-tel-input": VueTelInput
  },
  data: () => ({
    viewMode: {
      personalInfo: true,
      business: false
    },
    currentAccount: {},
    currentDetails: {},
    newDetails: {
      experience: null,
      profession: null,
      team_mode: "solo",
      brand_color: null
    }
  }),
  created() {
    this.loadCurrentUser();
  },
  methods: {
    getExteriorColor(color) {
      this.newDetails.brand_color = color;
    },
    updateCustomerProfile() {
      //this.$validator.validateAll().then(result => {
      //if (result) {

      this.newDetails.avatar = this.activeCroppedImage;
      this.newDetails.business_logo = this.defaultCropGallery[
        this.defaultCropGallery.length - 1
      ];
      var formData = this.formData(this.newDetails);
      let url = "customer/update-user-profile";
      let DispatchpParams = { formData: formData, url: url };
      this.$store
        .dispatch("dukaPostRequest", DispatchpParams)
        .then(response => {
          console.log(response.data);
        });
      //}
      //});
    },
    loadCurrentUser() {
      this.$store
        .dispatch("dukaGetRequest", "customer/get-current-member")
        .then(response => {
          this.currentDetails = response.data.user_details;
          this.currentAccount = response.data.user;
          const newDetails = {
            ...this.newDetails,
            ...response.data.user_details
          };
          this.newDetails = newDetails;
          console.log(newDetails);
        });
    }
  }
};
</script>
<style lang="css">
.business-logo-container {
  box-sizing: border-box;
  display: flex;
  margin-bottom: 16px;
  position: relative;
  background-color: rgb(249, 251, 253);
  cursor: pointer;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  flex-direction: column;
  -webkit-box-pack: center;
  justify-content: center;
  border-radius: 3px;
  padding: 54px 0px;
  border-width: 1px;
  border-style: solid;
  border-color: rgb(239, 242, 246);
  border-image: initial;
}
.color-list {
  margin-left: 0;
  margin-bottom: 28px;
}

.color-list li {
  padding: 0 5px;
  float: left;
  margin: 10px auto;
}
.color-list li:first-child {
  padding-left: 0;
}
.color-list li .btn {
  position: relative !important;
  width: 39px !important;
  height: 39px !important;
  border-radius: 40px !important;
  font-size: 8px !important;
  color: #666 !important;
  padding: 0;
  transition: border 0.2s ease-in-out;
  outline: none !important;
  border: none !important;
  white-space: normal !important;
}
.color-list li .btn:hover {
  border: 3px solid #438cca !important;
}
.color-list li .btn.selected {
  border: 3px solid #666 !important;
}
.color-list li .btn.selected:after {
  content: "\F5E0";
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1;
  color: #666;
  font-size: 18px;
  position: absolute;
  left: 8px;
  top: 8px;
}
</style>